var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Autocomplete, TextField, ThemeProvider } from '@mui/material';
import theme from '../theme';
import { isEmailAddress } from '../../tools';
var mergeEmails = function (emails, newInput) {
    var inputs = newInput.split(/[\,|\;|\s]+/g);
    var allEmails = __spreadArray(__spreadArray([], emails, true), inputs, true);
    var results = [];
    allEmails.reverse().forEach(function (email) {
        if (typeof email === 'string' && isEmailAddress(email) && results.indexOf(email) === -1) {
            results.push(email);
        }
    });
    return results.reverse();
};
var BulkEmailsInput = function (_a) {
    var onChange = _a.onChange, onKeydown = _a.onKeydown, _b = _a.value, value = _b === void 0 ? [] : _b, _c = _a.label, label = _c === void 0 ? "Emails" : _c;
    return (_jsx(ThemeProvider, __assign({ theme: theme }, { children: _jsx(Autocomplete, { multiple: true, freeSolo: true, value: value, autoSelect: true, renderInput: function (params) {
                return (_jsx(TextField, __assign({}, params, { label: label, placeholder: "email@example.com", onKeyDown: function (e) {
                        if (e.key === 'Tab' || e.key === ';' || e.key === ',') {
                            e.preventDefault();
                            var event_1 = new KeyboardEvent('keydown', {
                                key: 'Enter',
                                code: 'Enter',
                                keyCode: 13,
                                charCode: 13,
                                bubbles: true
                            });
                            e.target.dispatchEvent(event_1);
                        }
                    } })));
            }, onChange: function (e, new_value, reason) {
                var emails = new_value;
                if (reason === 'createOption' || reason === 'blur') {
                    var newOne = emails.at(-1);
                    if (typeof newOne === 'string') {
                        emails = mergeEmails(value, newOne);
                    }
                }
                onChange && onChange(emails);
            }, onInputChange: function (e, newInput) { return onKeydown && onKeydown(newInput); }, isOptionEqualToValue: function () { return false; }, options: [] }) })));
};
export default BulkEmailsInput;
